module.exports = __webpack_public_path__ + "static/media/1019788.e54e9dda.jpg";